/**
 * Created by intelligrape on 27/7/17.
 */
import React from 'react';

export default (props)=> (
    <div>
        {props.isLoading && <div className="main-loader">
            <div className="spinnerlogo"></div>
        </div>}
        {props.fromRoot && <div className="main-loader white-back">
            <div className="spinnerlogo"></div>
        </div>}
    </div>
)